import { render, staticRenderFns } from "./NewComposite.vue?vue&type=template&id=0835d20a&scoped=true&"
import script from "./NewComposite.vue?vue&type=script&lang=js&"
export * from "./NewComposite.vue?vue&type=script&lang=js&"
import style0 from "./NewComposite.vue?vue&type=style&index=0&id=0835d20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835d20a",
  null
  
)

export default component.exports